import AppLayout from '../AppLayout'
import PoloTerritorialeSection from './PoloTerritorialeSection'

export default function PoloTerritorialePage() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <section className="telemetry-dashboard">
          <div className="telemetry-inner">
            <PoloTerritorialeSection
              selectedAmbitoId={selectedAmbito}
              onSelectedAmbitoChange={onSelectedAmbitoChange}
            />
          </div>
        </section>
      )}
    </AppLayout>
  )
}
